import { Strong, Text } from '@customerio/pluma-components/react';
import { formatCentsToUsd } from '@/utils/currency';
import { fundingSummary, type AddFundsFunding, type FundingOutcome } from '../utils/add-funds';

type FundingOutcomeTextProps = {
  outcome: FundingOutcome;
  amountCents: number;
};

function FundingOutcomeText({ outcome, amountCents }: FundingOutcomeTextProps) {
  const amount = <Strong color="inherit">{formatCentsToUsd(amountCents)}</Strong>;
  switch (outcome.kind) {
    case 'covers':
      return (
        <>
          {amount} covers it{outcome.extraEmails == null ? '' : ` and ≈${outcome.extraEmails} more emails`}.
        </>
      );
    case 'above-estimate':
      return <>{amount} is above that estimate.</>;
    case 'short':
      return (
        <>
          {amount} isn't enough, pick <Strong color="inherit">{formatCentsToUsd(outcome.pickDollars * 100, 0)}</Strong>{' '}
          or more.
        </>
      );
    default: {
      const _exhaustive: never = outcome;
      return _exhaustive;
    }
  }
}

type AddFundsFundingLineProps = {
  funding: AddFundsFunding;
  amountCents: number;
};

export function AddFundsFundingLine({ funding, amountCents }: AddFundsFundingLineProps) {
  const summary = fundingSummary(funding, amountCents);
  return (
    <Text color="secondary" size="sm" data-test-add-funds-funding-line>
      {summary.subject} {summary.verb} <Strong color="inherit">≈{formatCentsToUsd(summary.needCents)}</Strong> (
      {summary.what}).
      {summary.outcome == null ? null : (
        <>
          {' '}
          <FundingOutcomeText outcome={summary.outcome} amountCents={amountCents} />
        </>
      )}
    </Text>
  );
}
